var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgLogout = function SvgLogout(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    fill: "none",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M.667 6.667h6.389L5.528 8.195a.667.667 0 0 0 .944.943l2.663-2.666.008-.008a.664.664 0 0 0-.003-.93L7.056 6.666l2.08-1.138-2.664-2.667a.667.667 0 0 0-.944.943l1.528 1.528H.666a.667.667 0 0 0 0 1.334M10 1.333H8.667a.667.667 0 1 1 0-1.333H10a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H8.667a.667.667 0 0 1 0-1.333H10a.667.667 0 0 0 .667-.667V2A.667.667 0 0 0 10 1.333",
    clipRule: "evenodd"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgLogout);
export { ForwardRef as ReactComponent };